import { render, staticRenderFns } from "./BaseLinkInput.vue?vue&type=template&id=5c91b49f&scoped=true&"
import script from "./BaseLinkInput.vue?vue&type=script&lang=js&"
export * from "./BaseLinkInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseLinkInput.vue?vue&type=style&index=0&id=5c91b49f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91b49f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c91b49f')) {
      api.createRecord('5c91b49f', component.options)
    } else {
      api.reload('5c91b49f', component.options)
    }
    module.hot.accept("./BaseLinkInput.vue?vue&type=template&id=5c91b49f&scoped=true&", function () {
      api.rerender('5c91b49f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseLinkInput.vue"
export default component.exports